export type BeneficiaryTypeGrantBody = {
	readonly kind: 'role' | 'user';
	readonly id: number;
	readonly level: string;
};

/** Replaces who may use the beneficiary dossier type; `level` is the sent value (`use` / `supervise`). */
class SaveBeneficiaryTypeGrants {
	constructor(
		public readonly accountId: number,
		public readonly usableBy: readonly BeneficiaryTypeGrantBody[],
	) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		return {
			usableBy: this.usableBy.map((grant) => ({ kind: grant.kind, id: grant.id, level: grant.level })),
		};
	}
}

export default SaveBeneficiaryTypeGrants;
